export { default } from './createGenerateClassName';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/createGenerateClassName/index.js
// module id = 471
// module chunks = 121